export const onResponseHandler = (data) => {
    if (data.sessionSubscriptionTypes && typeof data.sessionSubscriptionTypes === 'string') {
        data.sessionSubscriptionTypes = data.sessionSubscriptionTypes.replace(/\s/g, '').split(',');
    }

    if (data.sessionWrapperSubscriptionTypes && typeof data.sessionWrapperSubscriptionTypes === 'string') {
        data.sessionWrapperSubscriptionTypes = data.sessionWrapperSubscriptionTypes.replace(/\s/g, '').split(',');
    }

    data.realMode = data.realMode ?? 1;
    data.requestStamp = data.modifiedDate || Date.now();

    return data;
};
